import { resolveNumericOptionBounds } from '@/shared-question-model';
import { deduplicateOptions } from '@/shared-utilities';

interface Option {
  label: string;
  value: string;
}

/**
 * Hook for RatingScaleSelect component logic
 * Handles option sorting and label extraction
 */
export function useRatingScaleSelect(options: Option[]) {
  const { sortedOptions, low, high } = resolveNumericOptionBounds(
    deduplicateOptions(options)
  );
  const labels: [string, string] =
    low && high ? [low.label, high.label] : ['', ''];

  const hasLowLabelError = !labels[0];
  const hasHighLabelError = !labels[1];

  return {
    sortedOptions,
    labels,
    hasLowLabelError,
    hasHighLabelError,
  };
}
